module.exports = __webpack_public_path__ + "static/tyrant03-e73f12b338fc28ff9c0cfe7da1a82761.png";